const CAMERA_CONTROLLER_CONFIG = {
  minDistance: 3.2,
  maxDistance: 6,
  zoomSpeed: 0.4,
  mobileMinDistance: 4.2,
}

export { CAMERA_CONTROLLER_CONFIG };
